import api from '../utils/api'
import { API_ROOT } from '../constants'

/**
 * Submit sales form data to the backend
 * @param {Object} formData - The sales form data
 * @param {string} formData.name - Full name
 * @param {string} formData.businessEmail - Business email address
 * @param {string} formData.phoneNumber - Phone number
 * @param {string} formData.companyName - Company name
 * @param {string} formData.companySize - Company size category
 * @param {string} formData.websiteUrl - Website URL
 * @param {string} formData.reason - Reason for contacting
 * @param {string} formData.additionalInfo - Additional information (optional)
 * @param {Object} headers - Additional headers (including reCaptcha token)
 * @returns {Promise} API response
 */
export const submitSalesForm = async (formData, headers = {}) => {
  try {
    const response = await api.post(
      `${API_ROOT}/sales/contact`,
      {
        name: formData.name,
        businessEmail: formData.businessEmail,
        phoneNumber: formData.phoneNumber,
        companyName: formData.companyName,
        companySize: formData.companySize,
        websiteUrl: formData.websiteUrl,
        reason: formData.reason,
        additionalInfo: formData.additionalInfo || '',
        timestamp: new Date().toISOString(),
        source: 'sales-landing-page'
      },
      {
        headers: {
          'Content-Type': 'application/json',
          ...headers
        }
      }
    )

    return response.data
  } catch (error) {
    console.error('Sales form submission failed:', error)
    throw error
  }
}
